import { render } from "./EditCertificates.vue?vue&type=template&id=4f139f72"
import script from "./EditCertificates.vue?vue&type=script&lang=js"
export * from "./EditCertificates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__